export const navItems = [
  { id: "about-site", label: "本页说明" },
  { id: "features", label: "核心作用" },
  { id: "status", label: "地址状态" },
  { id: "recover", label: "找回指引" },
  { id: "bookmark", label: "防走失收藏" },
  { id: "faq", label: "常见问题" },
  { id: "safety", label: "安全提示" },
];

export const quickFacts = [
  {
    icon: "ri-time-line",
    label: "同步频率",
    value: "每日巡检",
    note: "发现变动即更新本页",
  },
  {
    icon: "ri-history-line",
    label: "最近核对",
    value: "2026-10-09",
    note: "本次入口状态正常",
  },
  {
    icon: "ri-bookmark-3-line",
    label: "推荐做法",
    value: "收藏本页",
    note: "换域名也不会走丢",
  },
  {
    icon: "ri-radar-line",
    label: "适用场景",
    value: "链接打不开",
    note: "先回本页核对入口",
  },
];

export const features = [
  {
    icon: "ri-links-fill",
    tag: "入口",
    title: "官网入口指引",
    desc: "汇总当前可用的官网入口路径，让你知道应该从哪里进入，避免在搜索结果里点到仿冒站点。",
  },
  {
    icon: "ri-refresh-line",
    tag: "同步",
    title: "最新地址同步",
    desc: "一旦站点更换域名或调整跳转方式，本页会第一时间同步，你只需回到这里重新获取即可。",
  },
  {
    icon: "ri-map-pin-2-line",
    tag: "收藏",
    title: "换域名防走失",
    desc: "记住「收藏本页」这一个动作，往后无论怎么改版，都能顺着本页找回入口，不必反复搜索。",
  },
  {
    icon: "ri-shield-check-line",
    tag: "安全",
    title: "真伪辨别提示",
    desc: "提供识别官方入口的要点，帮你区分官方页面与仿冒地址，减少误入钓鱼页面的风险。",
  },
  {
    icon: "ri-smartphone-line",
    tag: "教程",
    title: "多端收藏指导",
    desc: "电脑浏览器、手机主屏、二维码、笔记软件四种方式都给出具体步骤，换设备也能快速找回。",
  },
  {
    icon: "ri-question-answer-line",
    tag: "答疑",
    title: "常见问题解答",
    desc: "打不开怎么办、要不要清缓存、陌生链接该不该点，逐条给出可以直接照着做的建议。",
  },
];

export const statusLog = [
  {
    date: "2026-10-09",
    tag: "正常",
    title: "官网入口核对完成",
    detail: "本次巡检确认主入口与备用入口均可正常访问，页面跳转链路无异常，未发现需要变更的地址。",
  },
  {
    date: "2026-09-27",
    tag: "更新",
    title: "同步备用入口调整",
    detail: "备用入口的跳转参数做了小幅调整，本页已同步为最新版本，建议从本页重新进入一次以更新记录。",
  },
  {
    date: "2026-09-14",
    tag: "通知",
    title: "建议重新收藏本页",
    detail: "部分旧书签指向的历史地址已停止使用，请以本页展示的入口为准，并重新收藏本页作为备用。",
  },
  {
    date: "2026-08-30",
    tag: "维护",
    title: "短暂维护通告",
    detail: "当日入口进行了例行维护，访问期间可能出现短暂波动，目前已完全恢复，无需任何额外操作。",
  },
  {
    date: "2026-08-16",
    tag: "更新",
    title: "换域名场景说明更新",
    detail: "补充了换域名场景下的找回步骤，并将「先收藏本页」作为首选建议置顶展示，方便新老用户参照。",
  },
  {
    date: "2026-08-02",
    tag: "正常",
    title: "例行巡检通过",
    detail: "对入口可达性、跳转链路与页面提示文案做了整体核对，各项状态均为正常。",
  },
];

export const guideSteps = [
  {
    step: "01",
    icon: "ri-bookmark-3-line",
    title: "先把本页收藏起来",
    desc: "用浏览器的「添加到书签 / 收藏夹」把本页存好，命名建议写成「桃花视频导航」，方便以后一眼找到。",
  },
  {
    step: "02",
    icon: "ri-search-eye-line",
    title: "打不开时先回本页",
    desc: "当原链接失效或提示无法访问，不要急着在搜索里乱点，先回到本页核对当前可用入口，避免误入仿冒页。",
  },
  {
    step: "03",
    icon: "ri-login-box-line",
    title: "按本页指引重新进入",
    desc: "从本页给出的入口重新进入即可；若本页有更新说明，按说明操作。整个过程无需注册，也无需安装额外软件。",
  },
];

export const bookmarkMethods = [
  {
    key: "browser",
    label: "电脑浏览器",
    icon: "ri-computer-line",
    title: "浏览器收藏夹",
    desc: "适合长期在电脑上访问的用户，一次收藏，随时找回。",
    points: [
      "打开本页后按 Ctrl+D（Mac 为 Command+D）",
      "名称建议填写为「桃花视频导航」",
      "保存位置选择书签栏，方便随手点击",
      "建议同步到浏览器账号，换电脑后也能找回",
    ],
  },
  {
    key: "phone",
    label: "手机主屏",
    icon: "ri-smartphone-line",
    title: "添加到手机主屏",
    desc: "把本页当成一个小图标放在桌面，点开就是导航。",
    points: [
      "在手机浏览器中打开本页",
      "点击底部或顶部的「分享」按钮",
      "选择「添加到主屏幕」并确认名称",
      "桌面出现图标后即可一键直达本页",
    ],
  },
  {
    key: "qr",
    label: "二维码",
    icon: "ri-qr-code-line",
    title: "二维码提醒",
    desc: "适合多设备切换，把本页入口贴在便签或备忘录里。",
    points: [
      "用另一台设备为本页地址生成二维码",
      "把二维码截图保存到相册备用",
      "需要时直接扫码即可回到本页",
      "扫码后留意核对是否为同一页面",
    ],
  },
  {
    key: "note",
    label: "笔记备忘",
    icon: "ri-sticky-note-line",
    title: "笔记软件备忘",
    desc: "把本页地址记在常用笔记里，作为最后一道保险。",
    points: [
      "复制本页的完整地址",
      "粘贴到备忘录并加上标题与日期",
      "定期回来确认地址没有发生变化",
      "与书签方式搭配使用会更稳妥",
    ],
  },
];

export const faqs = [
  {
    q: "原链接打不开了，是不是就不能用了？",
    a: "多数情况只是入口或域名发生了变动。请先回到本页核对当前可用入口，再按本页指引重新进入即可，不必反复在搜索结果里寻找，以免误入仿冒页面。",
  },
  {
    q: "为什么建议收藏本页，而不是收藏原地址？",
    a: "原地址可能随改版失效，而本页会持续同步最新入口。收藏本页相当于记住了一个固定的「中转站」，之后无论地址怎么变化，都能顺着本页找回来。",
  },
  {
    q: "需要清理浏览器缓存才能访问吗？",
    a: "一般不需要。若页面显示异常，可以先尝试刷新或更换浏览器；只有在排查无果时，再考虑清理缓存，并始终以本页展示的入口为准。",
  },
  {
    q: "收到陌生人发来的入口链接，可以点吗？",
    a: "不建议直接点击。请以本页展示的入口为准，陌生人发送的地址有可能是仿冒页。若确实需要，请先回到本页核对后再决定是否访问。",
  },
  {
    q: "本页会收费或者要求注册吗？",
    a: "本页只做入口指引与信息同步，不会要求你注册账号、付费或下载任何软件。凡是提出此类要求的页面，都请提高警惕，必要时直接关闭。",
  },
  {
    q: "本页多久更新一次？",
    a: "本页按每日巡检的频率核对入口状态，一旦发现变动会尽快同步。你可以在「地址状态」分区查看最近的更新记录与说明。",
  },
];

export const safetyTips = [
  {
    icon: "ri-lock-line",
    title: "认准地址栏",
    desc: "进入前先确认地址栏与收藏的地址一致，警惕只差一个字或一个字母的仿冒域名。",
  },
  {
    icon: "ri-forbid-2-line",
    title: "拒接额外要求",
    desc: "正规入口不会要求付费、注册或安装插件，遇到此类要求请直接关闭页面。",
  },
  {
    icon: "ri-eye-line",
    title: "留意页面细节",
    desc: "仿冒页常出现错别字、密集弹窗或异常跳转，一旦发现异常应立即退出并核对入口。",
  },
  {
    icon: "ri-shield-star-line",
    title: "只用本页入口",
    desc: "把本页作为唯一可信来源，避免在来源不明的聚合站或群聊链接上冒险。",
  },
  {
    icon: "ri-delete-bin-line",
    title: "清理旧书签",
    desc: "失效的旧地址书签建议删除，只保留本页，减少误点仿冒页面和过期链接的机会。",
  },
  {
    icon: "ri-phone-line",
    title: "善用更新说明",
    desc: "若长时间无法访问，先回本页查看是否有维护或更新说明，再决定下一步操作。",
  },
];

export const browseTips = [
  {
    icon: "ri-time-line",
    title: "错峰访问更顺畅",
    desc: "晚间高峰时段页面可能稍慢，尝试错峰访问，体验通常会更稳定。",
  },
  {
    icon: "ri-refresh-line",
    title: "刷新与换浏览器",
    desc: "页面卡住时先刷新，或更换一个浏览器再试，多数临时问题都能解决。",
  },
  {
    icon: "ri-wifi-line",
    title: "检查网络环境",
    desc: "先确认网络本身正常，在 Wi-Fi 与移动数据之间切换对比，排除网络原因。",
  },
  {
    icon: "ri-calendar-check-line",
    title: "留意更新日期",
    desc: "访问前扫一眼「地址状态」的最近更新日期，心里更有底，也更放心。",
  },
];

export const footerLinks = [
  { id: "about-site", label: "本页说明" },
  { id: "status", label: "地址状态" },
  { id: "recover", label: "找回指引" },
  { id: "bookmark", label: "防走失收藏" },
  { id: "faq", label: "常见问题" },
  { id: "safety", label: "安全提示" },
];